package net.frozenbit.games.soundgame.dtos

import kotlinx.serialization.Serializable

@Serializable
sealed interface HostClientMessage

@Serializable
data class CreateGame(
    val sessionId: String?,
) : HostClientMessage

@Serializable
class VotingOptionsPresentationFinished() : HostClientMessage

@Serializable
class WinnerPresentationFinished() : HostClientMessage
